import { Injectable, inject } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  filter,
  from,
  map,
  take,
  tap,
} from 'rxjs';

import { Language, SDK } from '@plugins/middleware-sdk';

export const languageToString = ({ lang, locale }: Language): string => {
  if (!lang) return 'en';
  if (!locale) return lang;
  return `${lang}-${locale}`;
};

@Injectable({ providedIn: 'root' })
export class BrowserLanguageService {
  #locale = new BehaviorSubject<string | undefined>(undefined);
  #firstFetch = true;
  #isLoading = false;

  private sdk = inject(SDK);

  private get fetchAllowed(): boolean {
    return this.#firstFetch && !this.#isLoading;
  }

  get locale$(): Observable<string> {
    if (!this.fetchAllowed) {
      return this.#locale.asObservable().pipe(
        filter((locale): locale is string => locale !== undefined),
        take(1),
      );
    }
    this.#isLoading = true;
    return from(this.sdk.getBrowserLanguage()).pipe(
      map((language) => languageToString(language)),
      tap((locale) => {
        this.#locale.next(locale);
        this.#isLoading = false;
        this.#firstFetch = false;
      }),
    );
  }
}
